<template lang="pug">
  SspLayout.order-code-statistics(area="core")
    GenericTable(ref="grid" :loading="loading")
      tr(slot="thead")
        th Id
        th Name
        th Count
        th(width="250") Export
      tr(v-for="status in codeStatusStatistics" :class="{'disabled-row': status.filter === null}")
        td {{ status.name.id }}
        td {{ status.name.value }}
        td {{ status.count | number }}
        td.actions(width="50")
          span
            input#set(type="radio" v-model="status.filter" :name="status.name.id" :value="`${status.name.id}`")
            label(for="set") Set
          span.ml10
            input#not-set(type="radio" v-model="status.filter" :name="status.name.id" :value="`!${status.name.id}`")
            label(for="not-set") Not set
          span.ml10
            input#any(type="radio" v-model="status.filter" :name="status.name.id" :value="null")
            label(for="any") Ignore
      tr(slot="tfoot")
        td
        td
        td
        td
          button.btn.btn-default(@click="showCodesWithStatuses(false)" :disabled="!hasSetFilter")
            i.fa.fa-eye
            span.ml5 Show
          button.btn.btn-default.ml10(@click="showCodesWithStatuses(true)" :disabled="!hasSetFilter")
            i.fa.fa-download
            span.ml5 Download

</template>

<script>
import miniToastr from 'mini-toastr'
import GenericTable from '@/components/common/GenericTable'
import Core from '@/service/apis/Core'
import { numberFilter } from '@/filters/filters'

export default {
  data: () => ({
    loading: false,
    codeStatusStatistics: []
  }),
  created() {
    this.fetchData()
  },
  methods: {
    mapFilter() {
      const filter = this.codeStatusStatistics
        .filter((el) => el.filter !== null)
        .map((el) => el.filter)
      return filter
    },
    fetchData() {
      this.loading = true
      Core.getOrderCodeStatusStatistics(this.orderId)
        .then((resp) => {
          resp.data.status.forEach((s) => {
            const status = s
            status.filter = null
            this.codeStatusStatistics.push(status)
          })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.loading = false
        })
    },
    showCodesWithStatuses(download) {
      const filter = this.mapFilter()

      if (filter.length !== 0) {
        if (download) {
          window.location = `/ssp/kcengine-ws-rest/expansion/filtered/${this.orderId}.csv?filter='${filter.join(',')}&download=1`
        } else {
          window.location = `/ssp/kcengine-ws-rest/expansion/filtered/${this.orderId}.csv?filter=${filter.join(',')}`
        }
      } else {
        miniToastr.error('You have to set at least one filter to not set or set')
      }
    }
  },
  computed: {
    hasSetFilter() {
      const filter = this.mapFilter()

      if (filter.length !== 0) {
        return true
      }
      return false
    },
    orderId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    GenericTable
  },
  filters: {
    number: numberFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/order/CodeStatusStatistics.vue